<ndt-user-preference-detail-view
   [user]="user$ | async"
   [callState]="callState$ | async"
   (savePreferences)="onSavePreferences($event)"
   (formSaveCancelled)="onCancel()"
>
</ndt-user-preference-detail-view>
